import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { Container } from "@mui/material";
import ExploreChip from "../ExploreChip/ExploreChip";
import styles from "./ExploreCourse.module.css";

import moment from "moment-timezone";
import SimpleBackdrop from "../../../components/Backdrop/SimpleBackdrop";
import SearchResult from "../../../components/SearchResult/SearchResult";
import { getUserData } from "../../../hooks/HelperFunctions";
import CategoryCarousel from "./CategoryCarousel";
import CurrencyDropdown from "../../CurrencyDropdown/CurrencyDropdown";
import { setActiveCurrency } from "../../../redux/currencySlice";

const ExploreCourse = (props) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const activeCurrency = useSelector((state) => state.currency.activeCurrency);

  const baseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  const { filterCheckBoxData } = props;
  const {
    updateCart,
    setUpdateCart,
    openSignUpModel,
    setOpenSignUpModel,
    enrollNowHandler,
    showSnackbarMessage,
  } = props;

  const [searchFor, setSearchFor] = useState("courses");

  const [courses, setCourses] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [totalCourseCount, setTotalCourseCount] = useState(0);
  const [courseLimit, setCourseLimit] = useState(9);
  const [sortBy, setSortBy] = useState("Newest");

  // filter data
  // const [topicCheckboxData, setTopicCheckboxData] = useState(filterCheckBoxData?.body?.topic);
  const [topicData, setTopicData] = useState(() => {
    if (filterCheckBoxData) {
      return filterCheckBoxData?.body?.topic;
    } else {
      return [];
    }
  });

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const getCourseList = () => {
    let postData = {};
    let userInfo = getUserData();
    let activeCurrencyFromLocalStorage = localStorage.getItem("activeCurrency");
    postData["searchFor"] = searchFor;
    postData["allCourses"] = true;
    postData["allTracks"] = true;
    postData["sortBy"] = sortBy;
    postData["limit"] = courseLimit;
    postData["checkBoxData"] = { topicData: topicData };
    postData["userId"] = userInfo?.id;
    postData["currency"] = activeCurrencyFromLocalStorage || "USD";
    postData["inprogressCourse"] = true;
    postData["upcomingCourse"] = true;
    setOpenBackdrop(true);

    if (searchFor == "courses" || searchFor == "all") {
      axios
        .post(`${baseUrl}/getCourses`, postData)
        .then((response) => {
          console.log("Response:", response.data);

          const totalCourseCount = response.data.totalRows;
          setTotalCourseCount(totalCourseCount);

          const allCourses = response?.data?.finalDataArrayGenaral?.filter(
            (singleCourse) =>
              singleCourse?.courseCardBtn === "show" ||
              singleCourse?.status === "public" ||
              singleCourse?.status === "active_for_track",
          );

          const today = moment();
          const filteredCourses = allCourses?.filter(
            (singleCourse) =>
              // For pre-recorded courses without enrollmentEndDate, include them
              // For courses with enrollmentEndDate, only include if enrollment is still open
              !singleCourse?.enrollmentEndDate ||
              today?.isBefore(moment(singleCourse?.enrollmentEndDate)),
          );

          // Sort courses by courseId descending (newest first) to ensure newly published courses appear at the top
          // const updatedCourses = filteredCourses?.sort((a, b) => b.courseId - a.courseId);
          const updatedCourses = filteredCourses;

          setCourses(updatedCourses);
          setTracks([]);
          setOpenBackdrop(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setOpenBackdrop(false);
        });
    } else if (searchFor == "diploma" || searchFor == "certificate") {
      axios
        .post(`${baseUrl}/getTrackCards`, postData)
        .then((response) => {
          console.log("Response:", response.data);

          const totalCourseCount = response.data.totalRows;
          setTotalCourseCount(totalCourseCount);

          const tracks = response.data.body;

          console.log(tracks);

          setTracks(tracks);
          setCourses([]);
          setOpenBackdrop(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setOpenBackdrop(false);
        });
    }
  };

  // console.log(filterCheckBoxData.body.topic);

  // useEffect(() => {
  //   console.log(topicData);
  // }, [topicData]);

  useEffect(() => {
    let activeCurrencyFromLocalStorage = localStorage.getItem("activeCurrency");
    if (
      (activeCurrencyFromLocalStorage &&
        activeCurrency == activeCurrencyFromLocalStorage) ||
      !activeCurrencyFromLocalStorage
    ) {
      getCourseList();
    }
  }, [courseLimit, searchFor, topicData, activeCurrency]);

  const [age, setAge] = useState("");
  const handleChanges = (event) => {
    setAge(event.target.value);
  };

  const coursesToShow = () => {
    let coursesLength = courses.length;
    let coursesNumberToShow = coursesLength;
    if (coursesLength >= 3 && coursesLength < 6) {
      coursesNumberToShow = 3;
    } else if (coursesLength >= 6 && coursesLength < 9) {
      coursesNumberToShow = 6;
    } else if (coursesLength >= 9) {
      coursesNumberToShow = 9;
    }

    return courses?.slice(0, coursesNumberToShow);
  };

  return (
    <>
      <SimpleBackdrop open={openBackdrop} />
      <div className={styles.exploreCourseBG}>
        <Container>
          <div className={styles.SectionTitle}>Explore Inspiring Courses</div>

          <div className={styles.ExploreChipSection}>
            <ExploreChip
              searchFor={searchFor}
              setSearchFor={setSearchFor}
              topicData={topicData}
              setTopicData={setTopicData}
              // topicCheckboxData={topicCheckboxData}
            />
            <div className={styles.CurrencyDropdownSection}>
              <CurrencyDropdown handleChange={handleChanges} />
            </div>
          </div>

          <SearchResult
            courses={coursesToShow()}
            tracks={tracks?.slice(0, 8)}
            searchFor={searchFor}
            setSearchFor={setSearchFor}
            totalCourseCount={totalCourseCount}
            setUpdateCart={setUpdateCart}
            enrollNowHandler={enrollNowHandler}
            courseLimit={courseLimit}
            setCourseLimit={setCourseLimit}
            checkboxHandler={() => {}}
            topicData={topicData}
            setTopicData={setTopicData}
            searchPage={false}
            setOpenSignUpModel={setOpenSignUpModel}
          />
        </Container>
      </div>
    </>
  );
};

export default ExploreCourse;
